import { UserRole } from '@app/core/models';
import { AnalyticReport } from '@app/core/models/admin/analytic-report';
import { createAction, props } from '@ngrx/store';

export const loadUserRoles = createAction('[Admin] Load Roles');
export const loadUserRolesSuccess = createAction('[Admin] Load Roles Success', props<{ payload: UserRole[] }>());

export const loadAnalyticReports = createAction('[Admin] Load AnalyticReports');
export const loadAnalyticReportsSuccess = createAction('[Admin] Load AnalyticReports Success', props<{ payload: AnalyticReport[] }>());
